import './global.css';
import React from 'react';
import ReactDom from 'react-dom';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { Provider } from 'react-redux';

// @source
import configureRoute from './routes/configure';
import configureStore from './redux/store/configure';
import WsConnect from './views/components/Chat/WsConnect';

const route = configureRoute();
const store = configureStore();

const App = () => (
  <Provider store={store}>
    <WsConnect />
    <Router basename={process.env.PUBLIC_URL}>
      <Switch>
        {route.map(config => <Route {...config} />)}
      </Switch>
    </Router>
  </Provider>
);

ReactDom.render(
  <App />,
  document.getElementById('app'),
);
